module.exports = __webpack_public_path__ + "fonts/bbc6c16a-06be-47c2-8266-1aab993bd7af.14701502.eot";